<div
  class="overview"
  *ngIf="overviewData"
  [ngClass]="[
    overviewData.previous && !overviewData.next ? 'overview--pr' : 'overview--pl',
    !overviewData.previous && !overviewData.next ? 'overview--small' : 'overview--big',
    overviewData.previous && overviewData.next ? 'overview--no-padding' : ''
  ]">
  <svg-icon
    *ngIf="overviewData.previous"
    key="slider-left"
    size="xl"
    class="mr-6 cursor-pointer"
    (click)="previousExercises(overviewData)"></svg-icon>
  <div class="overview__container">
    <h4>{{ 'f.overview-table.title' | translate }}</h4>
    <table *ngIf="overviewData.exercise.length > 0" class="overview__table">
      <tr>
        <th class="overview__table--no-border"></th>
        <th *ngFor="let exercise of overviewData.exercise; let i = index" class="overview__table--tight">{{ exercise.order + 1 }}</th>
      </tr>
      <tr>
        <td class="text-left font-medium overview__table--wide">
          <span class="pl-2">{{ 'f.overview-table.score' | translate }}</span>
        </td>
        <ng-container *ngFor="let exercise of overviewData.exercise">
          <td class="font-medium" [ngClass]="{ 'bg-grey text-grisMedio2': !exercise.isEvaluable }">
            {{ exercise.score !== '-/undefined' ? exercise.score : '-' }}
          </td>
        </ng-container>
      </tr>
      <tr>
        <td class="text-left font-medium overview__table--wide">
          <span class="pl-2">{{ 'f.overview-table.grade' | translate }}</span>
        </td>
        <ng-container *ngFor="let exercise of overviewData.exercise">
          <td class="font-medium" [ngClass]="{ 'bg-grey text-grisMedio2': !exercise.isEvaluable }">{{ exercise.grade }}</td>
        </ng-container>
      </tr>
      <tr *ngIf="userService.isTeacher() && (activitiesFacade.averageGrades$ | async)?.length" class="overview__average">
        <td class="text-left overview__table--wide flex justify-between items-center">
          <span class="pl-2">{{ 'f.menu.group' | translate }}</span>
          <div class="relative flex" (mouseenter)="showTooltip = true" (mouseleave)="showTooltip = false">
            <svg-icon key="help" class="cursor-pointer aria-hidden mr-2" size="md"></svg-icon>
            <span *ngIf="showTooltip" class="overview__average-tooltip">{{
              'f.overviewTable.averageGrades.tooltipLabel' | translate
            }}</span>
          </div>
        </td>
        <ng-container *ngFor="let exercise of overviewData.exercise">
          <td class="font-normal" [ngClass]="{ 'bg-grey text-grisMedio2': !exercise.isEvaluable }">
            {{ !exercise.isEvaluable ? exercise.grade : (exercise.groupAverageGrade | decimalFormat: true) }}
          </td>
        </ng-container>
      </tr>
    </table>
    <div class="overview__total">
      <p>{{ 'f.overview-table.total' | translate }} {{ overviewData.total !== '-/NaN' ? overviewData.total : '-' }}</p>
      <p>{{ 'f.overview-table.average' | translate }} {{ overviewData.averageGrade | decimalFormat: true }}</p>
    </div>
  </div>
  <svg-icon
    *ngIf="overviewData.next"
    key="slider-right"
    size="xl"
    class="ml-6 cursor-pointer"
    (click)="nextExercises(overviewData)"></svg-icon>
</div>
